
define('text!product-purchase-modal/product-purchase-modal.html',[],function () { return '<div class="modal-content product-purchase-modal responsive-dialog">\n    <div data-bind="react: reactOptions"></div>\n</div>\n';});

